const t = "SharePoint Import";
function i(e, r) {
  return e === t ? "FileConnect" : r ?? e;
}
function c(e, r) {
  const n = r.trim().toLowerCase();
  return n ? [i(e), e].some(
    (o) => o.toLowerCase().includes(n)
  ) : !0;
}
export {
  i as fileTagLabel,
  c as matchesFileTagSearch
};
//# sourceMappingURL=file-tag-label.js.map
